import { z } from 'zod';

export const loginSchema = z.object({
    email: z
        .string()
        .min(1, 'Email is required')
        .email('Enter a valid email address')
        .max(255, 'Email is too long'),
    password: z
        .string()
        .min(1, 'Password is required')
        .min(8, 'Password must be at least 8 characters long')
        .max(128, 'Password is too long'),
    remember_me: z.boolean().optional(),
});

export type LoginFormInputs = z.infer<typeof loginSchema>;
